import React from 'react';

const ImageModal = ({ open, src, alt, filename, onClose, onDownload, onDelete }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="relative max-w-4xl w-full mx-4">
        <div className="bg-white rounded-lg overflow-hidden shadow-xl">
          <div className="flex items-center justify-between p-3 border-b">
            <div className="text-sm font-medium text-gray-700 truncate">{filename || alt}</div>
            <div className="flex items-center space-x-2">
              {onDownload && (
                <button onClick={onDownload} className="px-3 py-1 bg-blue-600 text-white rounded">Download</button>
              )}
              {onDelete && (
                <button onClick={onDelete} className="px-3 py-1 bg-red-600 text-white rounded">Delete</button>
              )}
              <button onClick={onClose} className="px-3 py-1 bg-gray-200 rounded">Close</button>
            </div>
          </div>
          <div className="p-4 bg-gray-900 flex items-center justify-center">
            <img src={src} alt={alt} className="max-h-[75vh] max-w-full object-contain" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
